// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__eD0PA","resendInfoText":"OnGoingPaymentBox_resendInfoText__1AaCy"};